import React, { useMemo } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import isBefore from 'date-fns/isBefore';
import { Icon } from '@daedalus/atlas/Icon';
import { Price } from '@daedalus/atlas/Price';
import { Text } from '@daedalus/atlas/Text';
import { calculatePriceType, PRICE_TYPE } from '@daedalus/core/src/_web/availability';
import { AvailabilityHotelEntity } from '@daedalus/core/src/availability/types';
import { dateFormat, dateToMiddayDate, UTS_DATE_FORMAT } from '@daedalus/core/src/utils/date';
import { getRoundingStrategy } from '@daedalus/core/src/utils/number';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1j651f7",
  propsAsIs: false
});
const _exp9 = /*#__PURE__*/() => Text;
const DayContainer = /*#__PURE__*/styled(_exp9())({
  name: "DayContainer",
  class: "dpysznc",
  propsAsIs: true
});
const _exp10 = /*#__PURE__*/() => Text;
const PriceWrapper = /*#__PURE__*/styled(_exp10())({
  name: "PriceWrapper",
  class: "pgverv7",
  propsAsIs: true
});
interface Props {
  day: Date;
  hotelAvailabilityPrices?: AvailabilityHotelEntity;
  searchComplete?: boolean;
  showTotalPrices?: boolean;
  noHighPrices?: boolean;
  noUnavailabilityIcon?: boolean;
  shouldShowPrices: boolean;
}
const getPriceType = (hotelAvailabilityPrices: AvailabilityHotelEntity, price: number, noHighPrices: boolean, date: string) => {
  if (price) {
    const type = calculatePriceType(hotelAvailabilityPrices, price, date);
    if (type === PRICE_TYPE.HIGH && noHighPrices) {
      return PRICE_TYPE.NEUTRAL;
    }
    return type;
  }
  return PRICE_TYPE.NEUTRAL;
};
export const ColorPriceDayInner: React.FC<Props> = ({
  day,
  hotelAvailabilityPrices,
  searchComplete,
  showTotalPrices,
  noHighPrices = false,
  noUnavailabilityIcon = false,
  shouldShowPrices
}) => {
  const stringDate = dateFormat(day, UTS_DATE_FORMAT);
  const {
    price,
    currency,
    priceType,
    displayPrice
  } = useMemo(() => {
    if (!hotelAvailabilityPrices) {
      return {
        price: 0,
        currency: '',
        priceType: PRICE_TYPE.NEUTRAL,
        displayPrice: 0
      };
    }
    const price = hotelAvailabilityPrices[stringDate]?.cheapestNightlyRate;
    const currency = hotelAvailabilityPrices[stringDate]?.offers[0]?.currency;
    const priceType = getPriceType(hotelAvailabilityPrices, price, noHighPrices, stringDate);
    const rateBreakdown = hotelAvailabilityPrices[stringDate]?.cheapestPriceRateBreakdown;
    const displayPrice = showTotalPrices && rateBreakdown ? rateBreakdown.base + rateBreakdown.taxes + rateBreakdown.hotelFees : price;
    return {
      price,
      currency,
      priceType,
      displayPrice
    };
  }, [hotelAvailabilityPrices, showTotalPrices, stringDate, noHighPrices]);
  const isDateBeforeToday = isBefore(dateToMiddayDate(day), dateToMiddayDate(new Date()));
  const getFormattedDate = (date: Date) => date.toLocaleDateString('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  }).replaceAll(',', '');
  const shouldShowUnavailability = !noUnavailabilityIcon && !price && searchComplete && !isDateBeforeToday;
  const shouldShowLoader = !price && !searchComplete && shouldShowPrices;
  return <Wrapper className={cx(shouldShowPrices && 'shouldShowPrice', `day-inner ${priceType}`)} aria-label={getFormattedDate(day)} data-id={displayPrice ? 'DayWithPrice' : undefined}>
      <DayContainer variant="labelS">{day.getDate()}</DayContainer>
      {shouldShowPrices && displayPrice && <PriceWrapper variant="bodyXS" className="price">
          <Price noStyle currency={currency} value={displayPrice} roundingStrategy={getRoundingStrategy()} isAbbreviated useShortCurrency />
        </PriceWrapper>}
      {shouldShowUnavailability && <div className="forbidIcon">
          <Icon size="sm" name="Forbid" colorPath="content.neutral.c300" />
        </div>}
      {shouldShowLoader && <div className="loading">
          <Text variant="bodyXS" colorPath="content.neutral.c300">
            -
          </Text>
        </div>}
    </Wrapper>;
};

require("./ColorPriceDayInner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ColorPriceDayInner.tsx");